export default __webpack_public_path__ + "media/music/b49340f3ed37b0f4718d6c2b86f04c22.mp3";